@if (ticket) {

  <!-- Header (opcional) -->
  @if (showHeader) {
  <div class="flex items-start gap-5 mb-6">
    <div class="flex-shrink-0">
      <div class="flex h-16 w-16 items-center justify-center rounded-full {{ avatarColorClass }}">
        <span class="text-xl font-semibold">{{ initials }}</span>
      </div>
    </div>
    <div class="flex-1 min-w-0">
      <p class="text-xs text-gray-400 mb-1 font-mono">{{ ticket.ticketNumber }}</p>
      <h2 class="text-xl font-bold text-gray-900 dark:text-white mb-2">{{ ticket.subject }}</h2>
      <div class="flex flex-wrap gap-2">
        <app-badge [color]="getStatusColor(ticket.idTicketStatus)">{{ getStatusLabel(ticket.idTicketStatus) }}</app-badge>
        <app-badge [color]="getPriorityColor(ticket.idTicketPriority)">{{ getPriorityLabel(ticket.idTicketPriority) }}</app-badge>
        @if (ticket.idTicketCategory != null) {
          <span class="text-xs px-2 py-0.5 rounded-full font-medium bg-gray-100 text-gray-700 dark:bg-gray-800 dark:text-gray-300">
            {{ getCategoryName(ticket.idTicketCategory) }}
          </span>
        }
        <span class="text-xs px-2 py-0.5 rounded-full font-medium bg-blue-50 text-blue-700 dark:bg-blue-900/30 dark:text-blue-300">
          {{ origenLabel(ticket.source) }}
        </span>
        @if (sla) {
          <span class="text-xs px-2 py-0.5 rounded-full font-medium {{ slaStateColor }}">SLA: {{ slaStateLabel }}</span>
        }
      </div>
    </div>

    <!-- Followers toggle (estrella) + Ver completo -->
    <div class="flex-shrink-0 flex items-center gap-2">
      <button
        type="button"
        (click)="toggleFollow()"
        [disabled]="followerActionInFlight"
        [title]="isFollowing() ? 'Dejar de seguir' : 'Seguir ticket'"
        class="p-2 rounded-lg transition-colors disabled:opacity-50"
        [ngClass]="isFollowing()
          ? 'bg-yellow-50 text-yellow-500 hover:bg-yellow-100 dark:bg-yellow-900/20 dark:text-yellow-400'
          : 'bg-gray-50 text-gray-400 hover:bg-gray-100 dark:bg-gray-800 dark:text-gray-500'">
        <svg class="w-5 h-5" [attr.fill]="isFollowing() ? 'currentColor' : 'none'" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.196-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118L2.073 10.1c-.783-.57-.38-1.81.588-1.81h4.915a1 1 0 00.95-.69l1.523-4.673z"/>
        </svg>
      </button>
      <app-quick-actions-menu
        label="Acciones"
        align="right"
        [contactId]="ticket.idContact ?? undefined"
        [companyId]="ticket.idCompany ?? undefined"
        [dealId]="ticket.idDeal ?? undefined"
        (actionTriggered)="quickAction.emit()">
      </app-quick-actions-menu>
    </div>
  </div>
  }

  <!-- Tabs nav -->
  <div class="border-b border-gray-200 dark:border-gray-700 mb-5">
    <nav class="-mb-px flex gap-1 overflow-x-auto">
      <button (click)="onTabChange('info')"
        class="whitespace-nowrap px-4 py-2.5 text-sm font-medium border-b-2 transition-colors"
        [class.border-brand-500]="activeTab === 'info'"
        [class.text-brand-600]="activeTab === 'info'"
        [class.border-transparent]="activeTab !== 'info'"
        [class.text-gray-500]="activeTab !== 'info'">Información</button>

      <button (click)="onTabChange('conversation')"
        class="whitespace-nowrap px-4 py-2.5 text-sm font-medium border-b-2 transition-colors"
        [class.border-brand-500]="activeTab === 'conversation'"
        [class.text-brand-600]="activeTab === 'conversation'"
        [class.border-transparent]="activeTab !== 'conversation'"
        [class.text-gray-500]="activeTab !== 'conversation'">Conversación</button>

      <button (click)="onTabChange('timeline')"
        class="whitespace-nowrap px-4 py-2.5 text-sm font-medium border-b-2 transition-colors"
        [class.border-brand-500]="activeTab === 'timeline'"
        [class.text-brand-600]="activeTab === 'timeline'"
        [class.border-transparent]="activeTab !== 'timeline'"
        [class.text-gray-500]="activeTab !== 'timeline'">Línea de tiempo</button>

      <button (click)="onTabChange('sla')"
        class="whitespace-nowrap px-4 py-2.5 text-sm font-medium border-b-2 transition-colors"
        [class.border-brand-500]="activeTab === 'sla'"
        [class.text-brand-600]="activeTab === 'sla'"
        [class.border-transparent]="activeTab !== 'sla'"
        [class.text-gray-500]="activeTab !== 'sla'">SLA</button>

      <button (click)="onTabChange('csat')"
        class="whitespace-nowrap px-4 py-2.5 text-sm font-medium border-b-2 transition-colors"
        [class.border-brand-500]="activeTab === 'csat'"
        [class.text-brand-600]="activeTab === 'csat'"
        [class.border-transparent]="activeTab !== 'csat'"
        [class.text-gray-500]="activeTab !== 'csat'">CSAT</button>

      <!-- Inc 73: un subticket no gestiona vínculos — la pestaña se oculta. -->
      @if (!esSubTicket) {
        <button (click)="onTabChange('links')"
          class="whitespace-nowrap px-4 py-2.5 text-sm font-medium border-b-2 transition-colors"
          [class.border-brand-500]="activeTab === 'links'"
          [class.text-brand-600]="activeTab === 'links'"
          [class.border-transparent]="activeTab !== 'links'"
          [class.text-gray-500]="activeTab !== 'links'">Vínculos</button>
      }

      <button (click)="onTabChange('merged')"
        class="whitespace-nowrap px-4 py-2.5 text-sm font-medium border-b-2 transition-colors"
        [class.border-brand-500]="activeTab === 'merged'"
        [class.text-brand-600]="activeTab === 'merged'"
        [class.border-transparent]="activeTab !== 'merged'"
        [class.text-gray-500]="activeTab !== 'merged'">Fusionados</button>
    </nav>
  </div>

  <!-- ====== TAB: INFO ====== -->
  @if (activeTab === 'info') {
  <div class="space-y-5">

    <div class="grid grid-cols-2 gap-4">
      <div>
        <p class="text-xs text-gray-500 dark:text-gray-400">Pipeline</p>
        <p class="text-sm font-medium text-gray-900 dark:text-white">{{ ticket.pipelineName || getPipelineName(ticket.idPipeline) }}</p>
      </div>
      <div>
        <p class="text-xs text-gray-500 dark:text-gray-400">Etapa</p>
        <p class="text-sm font-medium text-gray-900 dark:text-white">{{ ticket.stageName || getStageName(ticket.idStage) }}</p>
      </div>
      <div>
        <p class="text-xs text-gray-500 dark:text-gray-400">Asignado a</p>
        <p class="text-sm font-medium text-gray-900 dark:text-white">{{ ticket.ownerUserName || '-' }}</p>
      </div>
      <div>
        <p class="text-xs text-gray-500 dark:text-gray-400">Creador</p>
        <!-- Sin creador = lo abrió una automatización (chatflow, formulario, correo): «Sistema»,
             que es un autor concreto, no un dato que falte. -->
        <p class="text-sm font-medium text-gray-900 dark:text-white">{{ ticket.creatorUserName || 'Sistema' }}</p>
      </div>
      <div>
        <p class="text-xs text-gray-500 dark:text-gray-400">Creado</p>
        <p class="text-sm font-medium text-gray-900 dark:text-white">{{ ticket.datetimeCreated | date:'dd/MM/yyyy HH:mm' }}</p>
      </div>
      <div>
        <p class="text-xs text-gray-500 dark:text-gray-400">Actualizado</p>
        <p class="text-sm font-medium text-gray-900 dark:text-white">{{ ticket.datetimeUpdated | date:'dd/MM/yyyy HH:mm' }}</p>
      </div>
      @if (ticket.firstResponseAt) {
        <div>
          <p class="text-xs text-gray-500 dark:text-gray-400">1ra respuesta</p>
          <p class="text-sm font-medium text-gray-900 dark:text-white">{{ ticket.firstResponseAt | date:'dd/MM/yyyy HH:mm' }}</p>
        </div>
      }
      @if (ticket.resolvedAt) {
        <div>
          <p class="text-xs text-gray-500 dark:text-gray-400">Resuelto</p>
          <p class="text-sm font-medium text-gray-900 dark:text-white">{{ ticket.resolvedAt | date:'dd/MM/yyyy HH:mm' }}</p>
        </div>
      }
      @if (ticket.reopenedCount > 0) {
        <div>
          <p class="text-xs text-gray-500 dark:text-gray-400">Reaberturas</p>
          <p class="text-sm font-medium text-gray-900 dark:text-white">{{ ticket.reopenedCount }}</p>
        </div>
      }
    </div>

    @if (ticket.description) {
      <div class="pt-4 border-t border-gray-200 dark:border-gray-700">
        <p class="text-xs text-gray-500 dark:text-gray-400 mb-1">Descripción</p>
        <p class="text-sm text-gray-700 dark:text-gray-300 whitespace-pre-line">{{ ticket.description }}</p>
      </div>
    }

    <div class="pt-4 border-t border-gray-200 dark:border-gray-700">
      <p class="text-xs font-semibold text-gray-500 dark:text-gray-400 uppercase tracking-wide mb-3">Asociaciones</p>
      <div class="grid grid-cols-3 gap-3">
        <div class="p-3 bg-gray-50 dark:bg-gray-800/50 rounded-lg border border-gray-100 dark:border-gray-700/50">
          <p class="text-xs text-gray-500 dark:text-gray-400">Contacto</p>
          <p class="text-sm font-medium text-gray-900 dark:text-white">{{ ticket.contactName || (ticket.idContact ? 'Contacto sin nombre disponible' : '—') }}</p>
        </div>
        <div class="p-3 bg-gray-50 dark:bg-gray-800/50 rounded-lg border border-gray-100 dark:border-gray-700/50">
          <p class="text-xs text-gray-500 dark:text-gray-400">Empresa</p>
          <p class="text-sm font-medium text-gray-900 dark:text-white">{{ ticket.companyName || (ticket.idCompany ? 'Empresa sin nombre disponible' : '—') }}</p>
        </div>
        @if (ticket.idDeal != null) {
          <div class="p-3 bg-gray-50 dark:bg-gray-800/50 rounded-lg border border-gray-100 dark:border-gray-700/50">
            <p class="text-xs text-gray-500 dark:text-gray-400">Negocio</p>
            <p class="text-sm font-medium text-gray-900 dark:text-white">{{ ticket.dealName || 'Negocio sin nombre disponible' }}</p>
          </div>
        }
        <!-- Inc 73: ticket padre (sólo lectura) cuando este ticket es un subticket. -->
        @if (esSubTicket) {
          <div class="p-3 bg-gray-50 dark:bg-gray-800/50 rounded-lg border border-gray-100 dark:border-gray-700/50">
            <p class="text-xs text-gray-500 dark:text-gray-400">Ticket padre</p>
            <button type="button" (click)="verTicketPadre()"
              class="text-sm font-medium text-brand-600 dark:text-brand-400 hover:underline text-left">
              {{ parentLabel }}
            </button>
          </div>
        }
        <!-- Inc 25: trazabilidad del lead de origen, con enlace a su detalle. -->
        @if (ticket.idLead != null) {
          <div class="p-3 bg-gray-50 dark:bg-gray-800/50 rounded-lg border border-gray-100 dark:border-gray-700/50">
            <p class="text-xs text-gray-500 dark:text-gray-400">Creado desde lead</p>
            <button type="button" (click)="verLead(ticket.idLead)"
              class="text-sm font-medium text-brand-600 dark:text-brand-400 hover:underline text-left">
              {{ ticket.leadName || ('Lead #' + ticket.idLead) }}
            </button>
          </div>
        }
      </div>
    </div>

    <div class="pt-4 border-t border-gray-200 dark:border-gray-700">
      <p class="text-xs font-semibold text-gray-500 dark:text-gray-400 uppercase tracking-wide mb-3">
        Seguidores ({{ followers.length }})
      </p>

      @if (followers.length > 0) {
        <div class="flex flex-wrap gap-2 mb-3">
          @for (f of followers; track f.id) {
            <span class="inline-flex items-center gap-1 pl-2 pr-1 py-1 rounded-md bg-gray-100 dark:bg-gray-800 text-xs text-gray-700 dark:text-gray-300">
              {{ followerName(f) }}
              <button type="button" (click)="quitarSeguidor(f.intIdUser)"
                [disabled]="followerActionInFlight"
                title="Quitar seguidor"
                class="p-0.5 rounded hover:bg-gray-200 dark:hover:bg-gray-700 text-gray-400 hover:text-red-500 disabled:opacity-50">
                <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
                </svg>
              </button>
            </span>
          }
        </div>
      } @else {
        <p class="text-xs text-gray-400 mb-3">Sin seguidores todavía.</p>
      }

      <label class="mb-1.5 block text-xs font-medium text-gray-600 dark:text-gray-400">Agregar seguidor</label>
      <app-entity-select
        [value]="null"
        [searchFn]="userSearch"
        [labelFn]="userLabel"
        [sublabelFn]="userSublabel"
        [disabled]="followerActionInFlight"
        placeholder="Buscar usuario por nombre o correo…"
        (selected)="agregarSeguidor($event)">
      </app-entity-select>
    </div>

  </div>
  }

  <!-- ====== TAB: CONVERSACIÓN ====== -->
  @if (activeTab === 'conversation') {
  <div class="space-y-4">
    @if (loadingComments) {
      <div class="flex justify-center py-6">
        <div class="animate-spin rounded-full h-6 w-6 border-b-2 border-brand-500"></div>
      </div>
    }

    @if (commentError) {
      <div class="p-3 bg-error-50 dark:bg-error-500/10 border border-error-200 dark:border-error-500/20 rounded-lg text-sm text-error-700 dark:text-error-400">
        {{ commentError }}
      </div>
    }

    @if (!loadingComments && comments.length === 0) {
      <p class="text-sm text-gray-400 text-center py-6">No hay comentarios todavía.</p>
    }

    @for (c of comments; track c.id) {
      <div
        class="rounded-xl border p-4"
        [ngClass]="c.commentType === 'INTERNAL'
          ? 'bg-yellow-50 dark:bg-yellow-900/10 border-yellow-200 dark:border-yellow-800'
          : 'bg-white dark:bg-gray-900 border-gray-200 dark:border-gray-700'">
        <div class="flex items-center gap-2 mb-2 flex-wrap">
          @if (c.commentType === 'INTERNAL') {
            <span class="text-xs px-2 py-0.5 rounded-full bg-yellow-100 text-yellow-700 dark:bg-yellow-900/40 dark:text-yellow-300 font-medium">
              🔒 Nota interna
            </span>
          } @else {
            <span class="text-xs px-2 py-0.5 rounded-full bg-blue-100 text-blue-700 dark:bg-blue-900/40 dark:text-blue-300 font-medium">
              📧 Mensaje al cliente
            </span>
          }
          <span class="text-xs font-medium text-gray-600 dark:text-gray-300">{{ c.authorName || 'Cliente' }}</span>
          <span class="text-xs text-gray-400">{{ c.datetimeCreated | date:'dd/MM/yyyy HH:mm' }}</span>
          @if (c.editedAt) {
            <span class="text-xs text-gray-400 italic">(editado)</span>
          }
          @if (esComentarioPropio(c) && editingCommentId !== c.id) {
            <div class="ml-auto flex items-center gap-1">
              <button type="button" *appHasPermission="'tickets:edit'" (click)="iniciarEdicion(c)"
                class="text-xs px-2 py-0.5 rounded text-gray-500 hover:text-brand-600 hover:bg-gray-100 dark:hover:bg-gray-800">
                Editar
              </button>
              <button type="button" *appHasPermission="'tickets:delete'" (click)="eliminarComentario(c)"
                class="text-xs px-2 py-0.5 rounded text-gray-500 hover:text-red-600 hover:bg-gray-100 dark:hover:bg-gray-800">
                Eliminar
              </button>
            </div>
          }
        </div>

        @if (editingCommentId === c.id) {
          <!-- Modo edición inline -->
          <textarea [(ngModel)]="editCommentBody" rows="3"
            class="w-full rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 px-3 py-2 text-sm text-gray-900 dark:text-gray-100 focus:outline-none focus:ring-2 focus:ring-brand-500 resize-none"></textarea>

          @if (editCommentMentions.length > 0) {
            <div class="flex flex-wrap gap-1.5 mt-2">
              @for (m of editCommentMentions; track m.id) {
                <span class="inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-brand-50 text-brand-700 dark:bg-brand-900/30 dark:text-brand-300 text-xs">
                  &#64;{{ m.name }}
                  <button type="button" (click)="removeEditMention(m.id)" class="hover:text-red-500">&times;</button>
                </span>
              }
            </div>
          }
          <div class="mt-2">
            <app-entity-select
              [value]="null"
              [searchFn]="userSearch" [labelFn]="userLabel" [sublabelFn]="userSublabel"
              placeholder="Mencionar usuario…"
              (selected)="addEditMention($event)">
            </app-entity-select>
          </div>

          <div class="flex justify-end gap-2 mt-2">
            <button type="button" (click)="cancelarEdicion()"
              class="px-3 py-1.5 text-sm rounded-lg font-medium bg-gray-100 text-gray-600 dark:bg-gray-800 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-700">
              Cancelar
            </button>
            <button type="button" (click)="guardarEdicion(c)"
              [disabled]="savingEditComment || !editCommentBody.trim()"
              class="px-3 py-1.5 text-sm rounded-lg font-medium bg-brand-500 text-white hover:bg-brand-600 disabled:opacity-50 disabled:cursor-not-allowed">
              @if (savingEditComment) { Guardando… } @else { Guardar }
            </button>
          </div>
        } @else {
          <p class="text-sm text-gray-700 dark:text-gray-300 whitespace-pre-line">{{ c.bodyText }}</p>
          @if (c.mentionedUserNames && c.mentionedUserNames.length > 0) {
            <div class="flex flex-wrap gap-1.5 mt-2">
              @for (name of c.mentionedUserNames; track name) {
                <span class="inline-flex items-center px-2 py-0.5 rounded-full bg-brand-50 text-brand-700 dark:bg-brand-900/30 dark:text-brand-300 text-xs">
                  &#64;{{ name }}
                </span>
              }
            </div>
          }
        }
      </div>
    }

    <!-- Composer -->
    <div class="pt-4 border-t border-gray-200 dark:border-gray-700">
      <div class="flex items-center gap-2 mb-2">
        <button type="button"
          (click)="newCommentType = 'INTERNAL'"
          class="px-3 py-1 text-xs rounded-lg font-medium transition-colors"
          [ngClass]="newCommentType === 'INTERNAL'
            ? 'bg-yellow-100 text-yellow-700 dark:bg-yellow-900/40 dark:text-yellow-300'
            : 'bg-gray-100 text-gray-500 dark:bg-gray-800 dark:text-gray-400'">
          🔒 Nota interna
        </button>
        <button type="button"
          (click)="newCommentType = 'PUBLIC'"
          class="px-3 py-1 text-xs rounded-lg font-medium transition-colors"
          [ngClass]="newCommentType === 'PUBLIC'
            ? 'bg-blue-100 text-blue-700 dark:bg-blue-900/40 dark:text-blue-300'
            : 'bg-gray-100 text-gray-500 dark:bg-gray-800 dark:text-gray-400'">
          📧 Mensaje al cliente
        </button>
      </div>
      <textarea
        [(ngModel)]="newCommentBody"
        rows="3"
        [placeholder]="newCommentType === 'INTERNAL' ? 'Escriba una nota interna…' : 'Escriba el mensaje al cliente…'"
        class="w-full rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 px-3 py-2 text-sm text-gray-900 dark:text-gray-100 focus:outline-none focus:ring-2 focus:ring-brand-500 resize-none"></textarea>

      <!-- Menciones -->
      @if (newCommentMentions.length > 0) {
        <div class="flex flex-wrap gap-1.5 mt-2">
          @for (m of newCommentMentions; track m.id) {
            <span class="inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-brand-50 text-brand-700 dark:bg-brand-900/30 dark:text-brand-300 text-xs">
              &#64;{{ m.name }}
              <button type="button" (click)="removeMention(m.id)" class="hover:text-red-500">&times;</button>
            </span>
          }
        </div>
      }
      <div class="mt-2">
        <label class="mb-1 block text-xs font-medium text-gray-500 dark:text-gray-400">Mencionar usuario</label>
        <app-entity-select
          [value]="null"
          [searchFn]="userSearch" [labelFn]="userLabel" [sublabelFn]="userSublabel"
          placeholder="Buscar usuario para mencionar…"
          (selected)="addMention($event)">
        </app-entity-select>
      </div>

      <div class="flex justify-end mt-2">
        <button type="button"
          (click)="publicarComentario()"
          [disabled]="publishingComment || !newCommentBody.trim()"
          class="px-3 py-1.5 text-sm rounded-lg font-medium bg-brand-500 text-white hover:bg-brand-600 disabled:opacity-50 disabled:cursor-not-allowed transition-colors">
          @if (publishingComment) { Publicando… } @else { Publicar }
        </button>
      </div>
    </div>
  </div>
  }

  <!-- ====== TAB: TIMELINE ====== -->
  <!-- INC 67: homologada al componente compartido que usan contactos, negocios,
       empresas, leads y tareas. La fuente sigue siendo el audit log propio del
       ticket (GET /api/tickets/{id}/audit) — ver ticket-audit-timeline.util.ts. -->
  @if (activeTab === 'timeline') {
    <app-audit-timeline
      [logs]="auditLog"
      [loading]="loadingAudit"
      [error]="auditError"
      [currentPage]="auditPage"
      [totalPages]="auditTotalPages"
      [totalElements]="auditTotalElements"
      emptyMessage="No hay eventos de auditoría para este ticket."
      (pageChange)="cargarAudit($event)" />
  }

  <!-- ====== TAB: SLA ====== -->
  @if (activeTab === 'sla') {
  <div class="space-y-4">
    @if (loadingSla) {
      <div class="flex justify-center py-6">
        <div class="animate-spin rounded-full h-6 w-6 border-b-2 border-brand-500"></div>
      </div>
    }
    @if (slaError) {
      <div class="p-3 bg-error-50 dark:bg-error-500/10 border border-error-200 dark:border-error-500/20 rounded-lg text-sm text-error-700 dark:text-error-400">
        {{ slaError }}
      </div>
    }
    @if (!loadingSla && !slaError && !sla) {
      <p class="text-sm text-gray-400 text-center py-6">El ticket no tiene política SLA aplicada.</p>
    }

    @if (sla) {
      <div class="rounded-xl p-4 {{ slaStateColor }}">
        <p class="text-xs uppercase font-semibold tracking-wide opacity-80">Estado</p>
        <p class="text-2xl font-bold">{{ slaStateLabel }}</p>
        @if (sla.isPaused) {
          <p class="text-xs mt-1">Pausado desde {{ sla.pauseStartedAt | date:'dd/MM/yyyy HH:mm' }}</p>
        }
      </div>

      @if (sla.ownerUserName) {
        <div class="rounded-lg border border-gray-200 dark:border-gray-700 p-4">
          <p class="text-xs text-gray-500 dark:text-gray-400 uppercase mb-1">Usuario asignado</p>
          <p class="text-sm font-medium text-gray-900 dark:text-white">{{ sla.ownerUserName }}</p>
        </div>
      }

      <div class="grid grid-cols-2 gap-4">
        <div class="rounded-lg border border-gray-200 dark:border-gray-700 p-4">
          <p class="text-xs text-gray-500 dark:text-gray-400 uppercase mb-1">Primera respuesta</p>
          @if (sla.firstResponseAt) {
            <p class="text-sm font-medium text-gray-900 dark:text-white">
              Respondido: {{ sla.firstResponseAt | date:'dd/MM/yyyy HH:mm' }}
            </p>
            <p class="text-xs mt-1"
              [class.text-green-600]="sla.firstResponseMet"
              [class.text-red-600]="!sla.firstResponseMet">
              {{ sla.firstResponseMet ? 'Cumplido' : 'Vencido' }}
            </p>
          } @else if (sla.firstResponseDueAt) {
            <p class="text-sm font-medium text-gray-900 dark:text-white">
              Vence: {{ sla.firstResponseDueAt | date:'dd/MM/yyyy HH:mm' }}
            </p>
            <p class="text-xs mt-1"
              [class.text-red-600]="sla.isBreachedResponse"
              [class.text-yellow-600]="sla.warningResponseSent && !sla.isBreachedResponse"
              [class.text-gray-500]="!sla.warningResponseSent && !sla.isBreachedResponse">
              Restantes: {{ formatMinutes(getMinutesRemaining(sla.firstResponseDueAt)) }}
            </p>
          } @else {
            <p class="text-sm text-gray-400">—</p>
          }
        </div>

        <div class="rounded-lg border border-gray-200 dark:border-gray-700 p-4">
          <p class="text-xs text-gray-500 dark:text-gray-400 uppercase mb-1">Resolución</p>
          @if (sla.resolutionAt) {
            <p class="text-sm font-medium text-gray-900 dark:text-white">
              Resuelto: {{ sla.resolutionAt | date:'dd/MM/yyyy HH:mm' }}
            </p>
            <p class="text-xs mt-1"
              [class.text-green-600]="sla.resolutionMet"
              [class.text-red-600]="!sla.resolutionMet">
              {{ sla.resolutionMet ? 'Cumplido' : 'Vencido' }}
            </p>
          } @else if (sla.resolutionDueAt) {
            <p class="text-sm font-medium text-gray-900 dark:text-white">
              Vence: {{ sla.resolutionDueAt | date:'dd/MM/yyyy HH:mm' }}
            </p>
            <p class="text-xs mt-1"
              [class.text-red-600]="sla.isBreachedResolution"
              [class.text-yellow-600]="sla.warningResolutionSent && !sla.isBreachedResolution"
              [class.text-gray-500]="!sla.warningResolutionSent && !sla.isBreachedResolution">
              Restantes: {{ formatMinutes(getMinutesRemaining(sla.resolutionDueAt)) }}
            </p>
          } @else {
            <p class="text-sm text-gray-400">—</p>
          }
        </div>
      </div>

      @if (sla.totalPausedSeconds > 0) {
        <p class="text-xs text-gray-500 dark:text-gray-400">
          Tiempo total pausado: {{ formatMinutes(sla.totalPausedSeconds / 60) }}
        </p>
      }
    }
  </div>
  }

  <!-- ====== TAB: CSAT ====== -->
  @if (activeTab === 'csat') {
  <div class="space-y-4">
    @if (loadingCsat) {
      <div class="flex justify-center py-6">
        <div class="animate-spin rounded-full h-6 w-6 border-b-2 border-brand-500"></div>
      </div>
    }
    @if (csatError) {
      <div class="p-3 bg-error-50 dark:bg-error-500/10 border border-error-200 dark:border-error-500/20 rounded-lg text-sm text-error-700 dark:text-error-400">
        {{ csatError }}
      </div>
    }

    @if (csat) {
      <div class="rounded-xl border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-900 p-5">
        <div class="flex items-center gap-3">
          <div class="text-3xl font-bold text-purple-600 dark:text-purple-400">{{ csat.score }} / 5</div>
          <div class="flex-1">
            <p class="text-xs text-gray-500 dark:text-gray-400">Recibido</p>
            <p class="text-sm text-gray-700 dark:text-gray-300">{{ csat.submittedAt | date:'dd/MM/yyyy HH:mm' }}</p>
          </div>
        </div>
        @if (csat.feedback) {
          <p class="text-sm text-gray-700 dark:text-gray-300 mt-3 italic">"{{ csat.feedback }}"</p>
        }
      </div>
    } @else if (!loadingCsat && !csatError) {
      <!-- INC 22: la encuesta CSAT la responde el CLIENTE por el enlace enviado
           al resolver/cerrar el ticket. El agente NO registra el score. -->
      <div class="rounded-xl border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-900 p-6 flex flex-col items-center text-center gap-3">
        <div class="flex h-12 w-12 items-center justify-center rounded-full bg-purple-50 text-purple-500 dark:bg-purple-500/10 dark:text-purple-400">
          <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"></path>
          </svg>
        </div>
        <p class="text-sm font-medium text-gray-700 dark:text-gray-300">
          Se envió una encuesta de satisfacción al contacto al cerrar el ticket.
        </p>
        <p class="text-sm text-gray-500 dark:text-gray-400">
          Aún no ha respondido. La calificación aparecerá aquí cuando el cliente complete la encuesta.
        </p>
      </div>
    }
  </div>
  }

  <!-- ====== TAB: VÍNCULOS ====== -->
  @if (activeTab === 'links' && !esSubTicket) {
  <div class="space-y-3">
    <!-- Encabezado con CTA para crear sub-ticket -->
    <div class="flex items-center justify-between gap-2">
      <p class="text-xs font-semibold text-gray-500 dark:text-gray-400 uppercase tracking-wide">
        Tickets vinculados
      </p>
      <button type="button" (click)="abrirSubTicket()"
        class="inline-flex items-center gap-1.5 px-3 py-1.5 text-xs rounded-lg font-medium bg-brand-500 text-white hover:bg-brand-600 transition-colors">
        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"></path>
        </svg>
        Nuevo sub-ticket
      </button>
    </div>

    @if (loadingLinks) {
      <div class="flex justify-center py-6">
        <div class="animate-spin rounded-full h-6 w-6 border-b-2 border-brand-500"></div>
      </div>
    }
    @if (!loadingLinks && links.length === 0) {
      <div class="flex flex-col items-center gap-3 py-8">
        <p class="text-sm text-gray-400">Sin tickets vinculados.</p>
        <button type="button" (click)="abrirSubTicket()"
          class="inline-flex items-center gap-1.5 px-3 py-1.5 text-sm rounded-lg font-medium bg-brand-500 text-white hover:bg-brand-600 transition-colors">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"></path>
          </svg>
          Nuevo sub-ticket
        </button>
      </div>
    }
    @for (link of links; track link.id) {
      <div class="rounded-lg border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-900 p-3">
        <div class="flex items-center justify-between gap-2">
          <div class="min-w-0">
            <span class="text-xs px-2 py-0.5 rounded-full font-medium bg-blue-50 text-blue-700 dark:bg-blue-900/30 dark:text-blue-300">
              {{ linkTypeLabel(link.linkType) }}
            </span>
            <div class="mt-1.5 space-y-1">
              <div class="flex items-baseline gap-2">
                <span class="text-xs font-mono text-gray-400 flex-shrink-0">{{ link.parentTicketNumber || 'Ticket sin número disponible' }}</span>
                <span class="text-sm text-gray-900 dark:text-white truncate">{{ link.parentSubject || 'Ticket padre' }}</span>
              </div>
              <div class="flex items-baseline gap-2 pl-3">
                <span class="text-gray-400">↳</span>
                <span class="text-xs font-mono text-gray-400 flex-shrink-0">{{ link.childTicketNumber || 'Ticket sin número disponible' }}</span>
                <span class="text-sm text-gray-700 dark:text-gray-300 truncate">{{ link.childSubject || 'Ticket hijo' }}</span>
              </div>
            </div>
            @if (link.notes) {
              <p class="text-xs text-gray-500 dark:text-gray-400 italic mt-1">{{ link.notes }}</p>
            }
          </div>
          <span class="text-xs text-gray-400 flex-shrink-0">{{ link.datetimeCreated | date:'dd/MM/yyyy' }}</span>
        </div>
      </div>
    }
  </div>
  }

  <!-- ====== TAB: FUSIONADOS (Inc 52) ====== -->
  @if (activeTab === 'merged') {
  <div class="space-y-3">
    <p class="text-xs font-semibold text-gray-500 dark:text-gray-400 uppercase tracking-wide">
      Tickets fusionados en este
    </p>

    @if (loadingMerged) {
      <div class="flex justify-center py-6">
        <div class="animate-spin rounded-full h-6 w-6 border-b-2 border-brand-500"></div>
      </div>
    }
    @if (!loadingMerged && merged.length === 0) {
      <p class="text-sm text-gray-400 text-center py-8">No hay tickets fusionados en este.</p>
    }
    @for (m of merged; track m.id) {
      <div class="rounded-lg border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-900 p-3">
        <div class="flex items-center justify-between gap-2">
          <div class="min-w-0">
            <div class="flex items-baseline gap-2">
              <span class="text-xs font-mono text-gray-400 flex-shrink-0">{{ m.ticketNumber }}</span>
              <span class="text-sm text-gray-900 dark:text-white truncate">{{ m.subject }}</span>
            </div>
          </div>
          @if (m.statusName) {
            <app-badge [color]="getStatusColor(m.statusId)">{{ m.statusName }}</app-badge>
          }
        </div>
      </div>
    }
  </div>
  }

  <!-- Modal de creación de sub-ticket (accesible desde la pestaña Vínculos,
       tanto en el drawer de vista rápida como en la página completa) -->
  <app-tickets-actions-modals
    [ticket]="ticket"
    [action]="subTicketAction"
    [priorities]="priorities"
    [categories]="categories"
    (closed)="cerrarSubTicket()"
    (saved)="onSubTicketCreado($event)">
  </app-tickets-actions-modals>

}
